// Import necessary dependencies
import { RouteRecordRaw } from "vue-router";
import useConfirmations from "../composables/useConfirmations";

export default {
  path: "/services/confirmation",
  name: "services.confirmation",
  component: () => import("@/modules/confirmations/pages/ShowPage.vue"),
  props: true,
  beforeEnter: (to, from, next) => {
    const { confirmations } = useConfirmations();

    // Check if confirmations is empty and there is no id in the URL
    if (confirmations.value.length === 0 && !to.query.id) {
      // Redirect to dashboard if both conditions are true
      next({ name: "dashboard" });
    } else {
      // Allow access otherwise
      next();
    }
  },
} as RouteRecordRaw;
